import {
  AlertPanel,
  DataLabel,
  DropDown,
  InputText,
  Radio,
  Seperator,
  ALink,
  Dialog,
  ELink,
  CommonButton2,
  CommonButtonSecondary
} from "components2/CommonUI";
import { MODE_OF_CONTACT } from "constants/o2Appointment";
import { useOtpTime } from "hooks";
import moment from "moment";
import React, { useRef } from "react";
import { useImperativeHandle } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  clearEmailInfo,
  clearMobileInfo,
  updateEmail,
  updateEmailFromUCD,
  updateEmailUseUCD,
  updateMobileNumber,
  updateMobileNumberFromUCD,
  updateMobileUseUCD,
  updateModeOfContact,
  updateOtp,
  updateOtpToken,
  updateOtpTokenExpAt
} from "redux/o2Appointment";
import {
  getOtpSms,
  getOtpEmail,
  getUCDInfo,
  validateOtpSms,
  validateOtpEmail,
  getAliveCount
} from "services/api-service2";
import { isValidEmail, maskEmailAddress, safeVal } from "utils/common2";
import { isValidMobileNumber, isValidOTP, maskMobileNumber } from "utils/common2";
import _ from "lodash";
import ReCAPTCHA from "react-google-recaptcha";

export const SelectMobileNumber = () => {
  const dispatch = useDispatch();
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const { nric } = useSelector((state) => state.appointment);
  const { mobileUseUCD, mobileNumberFromUCD } = useSelector((state) => state.o2Appointment);

  useEffect(() => {
    dispatch(updateModeOfContact(MODE_OF_CONTACT.PHONE));
  }, []);

  useEffect(() => {
    if (isLogin) {
      getUCDInfo(nric).then(({ mobile }) => {
        if (mobile) {
          batch(() => {
            dispatch(updateMobileNumberFromUCD(mobile));
            dispatch(updateMobileUseUCD(true));
          });
        } else {
          batch(() => {
            dispatch(updateMobileNumberFromUCD(null));
            dispatch(updateMobileUseUCD(false));
          });
        }
      });
    }
  }, [isLogin, nric]);


  if (mobileNumberFromUCD === null) {
    return <></>;
  }

  return (
    <>
      <div className="row justify-content-center" style={{ marginBottom: 4 }}>
        <div className="col-12 col-md-8 col-lg-6">
          <div>
            <div>Select mobile number</div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <Radio
            id="mobileNumberTypeId"
            label={
              <>
                <div>{mobileNumberFromUCD}</div>
                <div className="second-row-caption">Retrieved from your CPF account settings.</div>
              </>
            }
            value={true}
            checked={mobileUseUCD}
            onChange={(e) => {
              dispatch(updateMobileUseUCD(true));
              dispatch(updateOtp(null));
              // if (apptType.isSlotAvailable) {
              //   onChangeApptType(e.target.value);
              // }
            }}
            needCol={false}
          />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <Radio
            id="mobileNumberTypeId"
            label={
              <>
                <div>Use another mobile number</div>
              </>
            }
            value={false}
            checked={!mobileUseUCD}
            onChange={(e) => {
              dispatch(updateMobileUseUCD(false));
              dispatch(updateOtp(null));
              // if (apptType.isSlotAvailable) {
              //   onChangeApptType(e.target.value);
              // }
            }}
            needCol={false}
          />
        </div>
      </div>
    </>
  );
};

// To do on blur enable action button.
// Initial value can be displayed value from store, if navigating from other page.
// Get OTP button will not be displayed if mobile is already been verified, which means OTP token exist in the store.
// When a change is made, OTP token will be set to null.
// Next button is disabled depending on Otp Token, which will be set to null when there is changes in value.
// 3 times exceed will prevent user from generating OTP. 
//
// eslint-disable-next-line react/display-name
export const InputMobileNumber = React.forwardRef((props, ref) => {
  const [error, setError] = useState(null);
  const [errorOtp, setErrorOtp] = useState(null);
  const { otp, nricFin, passport, mobileNumber: mobileNumberFromStore, otpToken } = useSelector((state) => state.o2Appointment);
  const [mobileNumber, setMobileNumber] = useState(mobileNumberFromStore);

  const dispatch = useDispatch();
  const { start: startOtpTime, stop: stopOtpTime, time: otpTime } = useOtpTime();
  const [ firstOtpTaken, setFirstOtpTaken] = useState(false);

  const [loading, setLoading] = useState(false);
  const [captchaResponseToken, setCaptchaResponseToken] = useState(null);

  useImperativeHandle(ref, () => ({
    validateOtp() {
      return new Promise((resolve) => {
        validateOtpSms({ identity: nricFin || passport, mobile: mobileNumber, otp }).then(
          ({ validation, otpToken, expAt }) => {
            if (validation) {
              dispatch(updateOtpToken(otpToken));
              dispatch(updateOtpTokenExpAt(expAt));
              resolve(true);
              return;
            }
            setErrorOtp("Please provide a valid OTP.");
            resolve(false);
          }
        );
      });
    }
  }));

  const onBlur = (hasTouched) => {
    if(!hasTouched && _.isEmpty(mobileNumber)) {
      return;
    }

    if(hasTouched && _.isEmpty(mobileNumber)) {
      setError("This field is mandatory.");
      return;
    }

    if (!isValidMobileNumber(mobileNumber)) {
      setError("Enter a valid Singapore mobile number (8 digits starting with 8 or 9).");
      return;
    }
    setError(null);
    dispatch(updateMobileNumber(mobileNumber.trim()));
  };

  const onBlurOtp = () => {
    if(!otp || otp.trim().length === 0) {
      return;
    }

    if (!isValidOTP(otp)) {
      setErrorOtp("Please provide a valid OTP.");
      return;
    }
    setErrorOtp(null);
  };

  const clkGetOtp = () => {
    if(loading) {
      return;
    }
    setLoading(true);

    getAliveCount({ mobile: mobileNumber, email: null }).then(({ count, exceed }) => {
      if (exceed) {
        setError(
          `This contact is currently in use for ${count} appointment bookings. Please use another contact.`
        );
      } else {
        getOtpSms({ identity: nricFin || passport, mobile: mobileNumber, captchaResponseToken }).then((status) => {
          console.log("status", status);
          if (status === "ok") {
            setFirstOtpTaken(true);
            startOtpTime(window.smsOtpExpSecsO2);
            dispatch(updateOtp(""));
          } else {
            // ask reCaptcha again
            setCaptchaResponseToken(null);
            setFirstOtpTaken(false);
          }
          setLoading(false);
        });
      }
    });
  };

  const onChange = (e) => {
    stopOtpTime();

    setMobileNumber(e.target.value.trim());

    setFirstOtpTaken(false);
    dispatch(updateOtp(null));
    dispatch(updateOtpToken(null));
    dispatch(updateOtpTokenExpAt(null));
  };

  const onChangeOtp = (e) => {
    dispatch(updateOtp(e.target.value.trim()));
  };

  const disabledOtpButton = captchaResponseToken === null || !isValidMobileNumber(mobileNumber);
  // const maskedMobileNumber = maskMobileNumber(mobileNumber);
  
  const onReCaptchaChange = (v) => {
    console.log("onReCaptchaChange", v);
    setCaptchaResponseToken(v);
  }

  const clkGetNewOTP = () => {
    setCaptchaResponseToken(null);
    setFirstOtpTaken(false);
  }


  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <InputText
            label="Mobile number"
            value={mobileNumber}
            onChange={onChange}
            isInvalid={error !== null}
            errorMessage={error}
            onBlur={onBlur}
          />
        </div>
      </div>
      {!firstOtpTaken && !otpToken && (
        <>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-12 col-md-8 col-lg-6 text-center" style={{display:"Flex", "justifyContent":"center"}}>
            <ReCAPTCHA
              sitekey={window.reCaptchaSiteKey}
              onChange={onReCaptchaChange}
            />
          </div>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-12 col-md-8 col-lg-6 text-center">
            <CommonButtonSecondary
              text={"Get OTP"}
              disabled={disabledOtpButton}
              onClick={()=>{
                clkGetOtp();
              }}
            />
          </div>
        </div>
        </>
      )}
      {firstOtpTaken && (
        <>
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <hr />
            </div>
          </div>
          <div className="row justify-content-center mt-2 sm-mb-32 md-mb-32 lg-mb-24 xl-mb-24">
            <div className="col-12 col-md-8 col-lg-6">
              A one-time password (OTP) has been delivered to mobile number <span style={{fontWeight: 600}}>{mobileNumber}</span>.
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <InputText
                label="Enter OTP"
                value={otp}
                onChange={onChangeOtp}
                isInvalid={errorOtp !== null}
                errorMessage={errorOtp}
                onBlur={onBlurOtp}
              />
            </div>
          </div>
          {otpTime !== null && (<div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24">
            <div className="col-12 col-md-8 col-lg-6">
              You can get a new OTP in {otpTime}.
            </div>
          </div>)}
          {otpTime === null && (
          <div className="row justify-content-center" style={{marginTop:24, marginBottom: 32}}>
            <div className="col-12 col-md-8 col-lg-6">
              <ALink onClick={clkGetNewOTP}>Get new OTP</ALink>
            </div>
          </div>)}
        </>
      )}
    </>
  );
});

// eslint-disable-next-line react/display-name
export const InputEmail = React.forwardRef((props, ref) => {
  const [error, setError] = useState(null);
  const [errorOtp, setErrorOtp] = useState(null);
  const { otp, nricFin, passport, email: emailFromStore, otpToken } = useSelector((state) => state.o2Appointment);
  const [email, setEmail] = useState(emailFromStore);

  const dispatch = useDispatch();
  const { start: startOtpTime, stop: stopOtpTime, time: otpTime } = useOtpTime();
  const [ firstOtpTaken, setFirstOtpTaken] = useState(false);

  const [loading, setLoading] = useState(false);
  const [captchaResponseToken, setCaptchaResponseToken] = useState(null);

  useImperativeHandle(ref, () => ({
    validateOtp() {
      return new Promise((resolve) => {
        validateOtpEmail({ identity: nricFin || passport, email, otp }).then(
          ({ validation, otpToken, expAt }) => {
            if (validation) {
              dispatch(updateOtpToken(otpToken));
              dispatch(updateOtpTokenExpAt(expAt));
              resolve(true);
              return;
            }
            setErrorOtp("Please provide a valid OTP.");
            resolve(false);
          }
        );
      });
    }
  }));

  const onBlur = (hasTouched) => {
    if(!hasTouched && _.isEmpty(email)) {
      return;
    }

    if(hasTouched && _.isEmpty(email)) {
      setError("This field is mandatory.");
      return;
    }

    if (!isValidEmail(email)) {
      setError("Enter a valid email address (e.g. yourname@email.com).");
      return;
    }
    setError(null);
    dispatch(updateEmail(email.trim().toUpperCase()));
  };

  const onBlurOtp = () => {
    if(!otp || otp.trim().length === 0) {
      return;
    }

    if (!isValidOTP(otp)) {
      setErrorOtp("Please provide a valid OTP.");
      return;
    }

    setErrorOtp(null);
  };

  const clkGetOtp = () => {
    if(loading) {
      return;
    }
    setLoading(true);

    getAliveCount({ mobile: null, email }).then(({ count, exceed }) => {
      if (exceed) {
        setError(
          `This contact is currently in use for ${count} appointment bookings. Please use another contact.`
        );
      } else {
        getOtpEmail({ identity: nricFin || passport, email, captchaResponseToken }).then((status) => {
          console.log("status", status);
          if (status === "ok") {
            setFirstOtpTaken(true);
            startOtpTime(window.emailOtpExpSecsO2);
            dispatch(updateOtp(""));
          } else {
            // ask reCaptcha again
            setCaptchaResponseToken(null);
            setFirstOtpTaken(false);
          }
          setLoading(false);
        });
      }
    });
  };

  const onChange = (e) => {
    stopOtpTime();
    setEmail(e.target.value.trim());

    setFirstOtpTaken(false);
    dispatch(updateOtp(null));
    dispatch(updateOtpToken(null));
    dispatch(updateOtpTokenExpAt(null));
  };

  const onChangeOtp = (e) => {
    dispatch(updateOtp(e.target.value.trim()));
  };

  const disabledOtpButton = captchaResponseToken === null || !isValidEmail(email);
  // const maskedEmailAddress = maskEmailAddress(email);

  const onReCaptchaChange = (v) => {
    console.log("onReCaptchaChange", v);
    setCaptchaResponseToken(v);
  }

  const clkGetNewOTP = () => {
    setCaptchaResponseToken(null);
    setFirstOtpTaken(false);
  }

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <InputText
            label="Email address"
            value={email}
            onChange={onChange}
            isInvalid={error !== null}
            errorMessage={error}
            onBlur={onBlur}
          />
        </div>
      </div>
      {!firstOtpTaken && !otpToken && (
        <>
          <div className="row justify-content-center mt-3 mb-3">
            <div className="col-12 col-md-8 col-lg-6 text-center" style={{display:"Flex", "justifyContent":"center"}}>
              <ReCAPTCHA
                sitekey={window.reCaptchaSiteKey}
                onChange={onReCaptchaChange}
              />
            </div>
          </div>
          <div className="row justify-content-center mt-3">
            <div className="col-12 col-md-8 col-lg-6 text-center">
              <CommonButtonSecondary
                text={"Get OTP"}
                disabled={disabledOtpButton}
                onClick={()=>{
                  clkGetOtp();
                }}
              />
            </div>
          </div>
        </>
      )}
      {firstOtpTaken && (
        <>
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <hr />
            </div>
          </div>
          <div className="row justify-content-center mt-2 sm-mb-32 md-mb-32 lg-mb-24 xl-mb-24">
            <div className="col-12 col-md-8 col-lg-6">
              A one-time password (OTP) has been delivered to email address{" "}
              <span style={{fontWeight: 600}}>{email.toUpperCase()}</span>.
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <InputText
                label="Enter OTP"
                value={otp}
                onChange={onChangeOtp}
                isInvalid={errorOtp !== null}
                errorMessage={errorOtp}
                onBlur={onBlurOtp}
              />
            </div>
          </div>
          {otpTime !== null && (<div className="row justify-content-center sm-mt-32 md-mt-32 lg-mt-24 xl-mt-24">
          <div className="col-12 col-md-8 col-lg-6">
            You can get a new OTP in {otpTime}.
            </div>
          </div>)}
          {otpTime === null && (
          <div className="row justify-content-center" style={{marginTop:24, marginBottom: 32}}>
            <div className="col-12 col-md-8 col-lg-6">
              <ALink onClick={clkGetNewOTP}>Get new OTP</ALink>
            </div>
          </div>)}
        </>
      )}
    </>
  );
});

export const SelectModeOfContact = () => {
  const dispatch = useDispatch();
  const { modeOfContact } = useSelector((state) => state.o2Appointment);

  return (
    <>
      <div className="row justify-content-center" style={{ marginBottom: 4 }}>
        <div className="col-12 col-md-8 col-lg-6">
          <div>
            <div>Mode of contact</div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center pb-3">
        <div className="col-12 col-md-4 col-lg-3">
          <div>
            <Radio
              id="modeOfContact"
              label={
                <>
                  <div>Mobile phone</div>
                </>
              }
              value={MODE_OF_CONTACT.PHONE}
              checked={MODE_OF_CONTACT.PHONE === modeOfContact}
              onChange={(e) => {
                batch(() => {
                  dispatch(updateModeOfContact(MODE_OF_CONTACT.PHONE));
                  dispatch(clearEmailInfo());
                  dispatch(updateOtpToken(null));
                  dispatch(updateOtpTokenExpAt(null));
                });
              }}
              needCol={false}
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-lg-3">
          <div>
            <div>
              <Radio
                id="modeOfContact"
                label={
                  <>
                    <div>Email</div>
                  </>
                }
                value={MODE_OF_CONTACT.EMAIL}
                checked={MODE_OF_CONTACT.EMAIL === modeOfContact}
                onChange={(e) => {
                  batch(() => {
                    dispatch(updateModeOfContact(MODE_OF_CONTACT.EMAIL));
                    dispatch(clearMobileInfo());
                    dispatch(updateOtpToken(null));
                    dispatch(updateOtpTokenExpAt(null));
                  });
                }}
                needCol={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const SelectEmail = () => {
  const dispatch = useDispatch();
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const { nric } = useSelector((state) => state.appointment);
  const { emailUseUCD, emailFromUCD } = useSelector((state) => state.o2Appointment);

  useEffect(() => {
    dispatch(updateModeOfContact(MODE_OF_CONTACT.EMAIL));
  }, []);

  useEffect(() => {
    if (isLogin) {
      getUCDInfo(nric).then(({ email }) => {
        if (email) {
          batch(() => {
            dispatch(updateEmailFromUCD(email));
            dispatch(updateEmailUseUCD(true));
          });
        } else {
          batch(() => {
            dispatch(updateEmailFromUCD(null));
            dispatch(updateEmailUseUCD(false));
          });
        }
      });
    }
  }, [isLogin, nric]);

  if (emailFromUCD === null) {
    return <></>;
  }

  return (
    <>
      <div className="row justify-content-center" style={{ marginBottom: 4 }}>
        <div className="col-12 col-md-8 col-lg-6">
          <div>
            <div>Select email address</div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <Radio
            id="emailTypeId"
            label={
              <>
                <div>{emailFromUCD}</div>
                <div className="second-row-caption">Retrieved from your CPF account settings.</div>
              </>
            }
            value={true}
            checked={emailUseUCD}
            onChange={(e) => {
              dispatch(updateEmailUseUCD(true));
              dispatch(updateOtp(null));
              // if (apptType.isSlotAvailable) {
              //   onChangeApptType(e.target.value);
              // }
            }}
            needCol={false}
          />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <Radio
            id="emailTypeId"
            label={
              <>
                <div>Use another email address</div>
              </>
            }
            value={false}
            checked={!emailUseUCD}
            onChange={(e) => {
              dispatch(updateEmailUseUCD(false));
              dispatch(updateOtp(null));
              // if (apptType.isSlotAvailable) {
              //   onChangeApptType(e.target.value);
              // }
            }}
            needCol={false}
          />
        </div>
      </div>
    </>
  );
};
